<div>
  <nav-head></nav-head>
  <router-outlet></router-outlet>
  <mat-spinner *ngIf="loading"></mat-spinner>
</div>